import { Actions } from "../table/table.actions"
import createTableReducer, { DEFAULT_STATE } from "../table/table.reducer"

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  defaultSorting: ["start_date=desc", "updated_at=desc"],
  sorting: ["start_date=desc"],
}

const contractsTableReducer = (state = INITIAL_STATE, action: Actions) =>
  createTableReducer("CONTRACTS_TABLE", {})(state, action)

export default contractsTableReducer
